import { cn } from '@/lib/utils';

/** Bramble's App Store listing. Every App Store link on the site uses this. */
export const APP_STORE_URL = 'https://apps.apple.com/us/app/bramble-for-parents/id6793615318';

export function AppStoreBadge({ className }: { className?: string }) {
  return (
    <a
      href={APP_STORE_URL}
      className={cn(
        'group inline-block transition-transform duration-200 hover:-translate-y-0.5 active:translate-y-0',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background',
        className,
      )}
      aria-label="Download Bramble on the App Store"
    >
      <img src="/app-store-badge.svg" alt="Download on the App Store" className="h-[3rem] w-auto" />
    </a>
  );
}
